import { Component, OnInit, TemplateRef } from '@angular/core';
import { TypeService } from '../type/type.service';
import { Type } from '../type/type';
//import { BranchService } from './type.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-type',
  templateUrl: './type.component.html',
  styleUrls: ['./type.component.css']
})
export class TypeComponent implements OnInit {

  sendMenuId: 36;
  sendPageName: string = 'Type';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  typeForm: FormGroup;
  types: Type[] = [];
  typesactive: Type[] = [];
  type: Type;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  typeModalRef: BsModalRef;
  operation: string;
  userid: number;
  typeid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered'

  }
  showall: boolean = true;
  showallstatus: boolean = false;
  constructor(
    private typeservice: TypeService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Type_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Type_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Type_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Type_action');
    }
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    // console.log(this._menuId); console.log(this._actionRights);
    this.typeForm = this.formBuilder.group({
      typeid: [''],
      type: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  key: string = 'type'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedtype");
    let data = arrays.find(ob => ob['name'] === 'Type');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedtype","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedtype",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.typeModalRef.hide();
  }

  getAll() {
    this.types = [];
    this.typesactive = [];
    this.typeservice.Get().subscribe(res => {
      this.types = res;
      if (this.showallstatus == true) {
        this.types.forEach(data => {
          if (data.active == 1) {
            this.typesactive.push(data);
          }
        });
        this.types = [];
        this.types = this.typesactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }
  getactiveinactive(showallp) {
    this.typesactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.types.forEach(data => {
        if (data.active == 1) {
          this.typesactive.push(data);
        }
      });
      this.types = [];
      this.types = this.typesactive;
    }
    else {
      this.showall = true;
      this.types = [];
      this.getAll();
    }
  }
  get g() { return this.typeForm.controls; }

  Post(type: Type) {

    this.submitted = true;
    // stop here if form is invalid
    //if (this.typeForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.typeForm.errors);
    //}

    if ((type.type.trim() == undefined) || (type.type.trim() == '')) {
      this.toastr.error('Type should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    type.type = type.type.trim();
    if (this.operation == 'add') {

      type.createdby = this.userid;
      msg = "Record Added Successfully";
      this.typeservice.Post(type).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.typeModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      type.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.typeservice.Put(type).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.typeModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.typeForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.typeForm.value.active = 1;
    } else {
      this.typeForm.value.active = 0
    }
  }

  OpenConfirmTemplate(type, template: TemplateRef<any>) {
    if (type.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.type = type;

          this.Delete();

        }

      });

  }


  Delete() {

    var msg;
    if (this.type.active == 0) {
      this.type.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.type.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.type.modifiedby = this.userid;

    this.typeservice.Delete(this.type).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }



  hidePopup() {
    this.typeModalRef.hide();
  }
  openTypeModal(template: TemplateRef<any>, otype, type?: Type) {


    this.operation = otype
    if (otype == 'update') {
      this.typeForm.controls['typeid'].setValue(type.typeid);
      this.typeForm.controls['type'].setValue(type.type);
      this.typeForm.controls['active'].setValue(type.active);
      this.type = type;
    }
    if (otype == 'add') {
      this.typeForm.controls['typeid'].setValue(0);
      this.typeForm.controls['type'].setValue('');
      this.typeForm.controls['active'].setValue(1);
    }
    this.typeModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }

}
